<ion-header [translucent]="true">
  <ion-toolbar>
    <div class="d__flex just-s header__">
      <h5 class="header m-0">Return Policy</h5>
      <ion-icon (click)="modal.dismiss()" class="mouse" name="close-outline"></ion-icon>
    </div>
  </ion-toolbar>
 
</ion-header>

<ion-content [fullscreen]="true">

  <div class="" >
    <ion-list  class="div_ p0 mouse" lines="none" *ngIf="issue_list && issue_list.length != 0">
      <ion-item (click)="go_to_product(item)" class="bb" *ngFor="let item of issue_list; let i = index;"  >
        <ion-label>
          <h6 class="headertexth6">{{item.heading}} <span *ngIf="item.no_of_days">/ {{item.no_of_days}}</span> </h6>
                <p class="pfont white_space">{{item.description}}</p>
        </ion-label>
        <!-- <ion-button fill="clear" class="manual-btn"   >Choose</ion-button>  -->
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      
    </ion-list>

    <app-no-record-found *ngIf="issue_list && issue_list.length == 0" [column]="true" [height]="db.ismobile ? 'calc(100vh - 65px)' : 'calc(100vh - 75px)'" heading="There’s no return policy found" [image]="'assets/return_policy.svg'"></app-no-record-found>

  </div>

</ion-content>
